import GameConfig from "../core/data/GameConfig";
import { LevelConfig } from "../types/LevelConfig";
import { AirInput } from "./AirInput";
import { Component } from "./Component";
import { Player } from "./Player";

export class PlayerMovement extends Component {
	obj: Player;

	targetY: number;
	topLane: number;
	bottomLane: number;

	vy = 0;

	maxSpeed: number;
	minSpeed: number;
	minJumpSpeed = GameConfig.get("minJumpSpeed") as number;
	speed: number;
	previousSpeed: number;
	resettingSpeed = false;
	onGround = true;
	readonly velocityMod = 25;
	enableMovement: boolean;
	enableLaneSwitch = true;
	static ON_HIT_GROUND = "onHitGround";
	events: Phaser.Events.EventEmitter;

	constructor(obj: Player, topLane: number, bottomLane: number) {
		super(obj);
		this.topLane = topLane;
		this.bottomLane = bottomLane;
		this.targetY = this.topLane;

		const levelConfigs = GameConfig.get("levels") as LevelConfig[];
		const config = levelConfigs.find((c) => c.id == this.obj.scene.level.name) as LevelConfig;
		this.minSpeed = config.minSpeed;
		this.speed = this.minSpeed;
		this.maxSpeed = config.maxSpeed;

		this.events = new Phaser.Events.EventEmitter();
	}

	update(dt: number): void {
		//old movement code
		//if (this.onGround) this.speed -= (this.speed - this.maxSpeed) * 3 * dt;

		if (this.enableMovement) {
			if (this.onGround && !this.resettingSpeed) this.speed += 4 * dt;
			else if (this.onGround && this.resettingSpeed) {
				this.speed -= (this.speed - this.previousSpeed) * 3 * dt;

				let flooredSpeed = Phaser.Math.FloorTo(this.speed);
				const flooredPrevSpeed = Phaser.Math.FloorTo(this.previousSpeed + this.velocityMod * 2);

				//console.log("Curr speed: " + flooredSpeed + " prev speed: " + flooredPrevSpeed);

				if (flooredSpeed <= flooredPrevSpeed) {
					flooredSpeed = flooredPrevSpeed;
					this.resettingSpeed = false;
					return;
				}
			}
			if (this.speed >= this.maxSpeed) this.speed = this.maxSpeed;
			if (this.speed <= this.minSpeed) this.speed = this.minSpeed;

			//console.log("Speed: " + this.speed);

			this.obj.x += this.speed * dt;
			this.obj.y -= (this.obj.y - this.targetY) * 6 * dt;

			const spine = this.obj.animator.spine;
			spine.y += this.vy * dt;
			if (spine.y > 0) {
				spine.y = 0;
				this.vy = 0;
				if (!this.onGround) {
					this.onGround = true;
					this.events.emit(PlayerMovement.ON_HIT_GROUND);
					this.obj.createBubble(false);
					this.resetSpeed();
					this.obj.setGroundInput();
				}
			}
			this.vy += 750 * dt;
		}
	}

	swipeUp(): void {
		if (!this.enableLaneSwitch) return;
		this.targetY = this.topLane;
	}

	swipeDown(): void {
		if (!this.enableLaneSwitch) return;
		this.targetY = this.bottomLane;
	}

	swapLanes(lane?: number): void {
		if (lane) {
			this.targetY = lane;
		} else {
			if (this.targetY == this.topLane) this.targetY = this.bottomLane;
			else this.targetY = this.topLane;
		}
	}

	bump(): void {
		this.obj.animator.play("Stumble");
		this.obj.playIdleNext();
		this.speed -= this.velocityMod * 2;
	}
	resetSpeed(): boolean {
		if (this.speed > this.previousSpeed) {
			this.resettingSpeed = true;
		} else this.resettingSpeed = false;
		return this.resettingSpeed;
	}

	jump(): void {
		const airInput = this.obj.getComponent(AirInput);
		if (airInput) {
			// console.log("AirInput Performed Trick: " + airInput.performedTrick);
			if (airInput.noInput) this.obj.animator.play("jump");
			else airInput.performedTrick = false;
		}

		this.vy = -600;
		this.onGround = false;
		this.previousSpeed = this.speed;
		if (this.speed < this.minJumpSpeed) this.speed = this.minJumpSpeed;
	}
}
